import React from 'react';
import { BookingStatus } from '@round/api';
import Badge from '../../../ui/Badge/Badge';
import styles from './BookingStatusBadge.module.css';
import cn from 'classnames';
import { StatusLabels } from '../../../utils/constants';

type BookingStatusBadgeProps = {
    status: BookingStatus;
    className?: string;
};

const BookingStatusBadge = ({ status, className }: BookingStatusBadgeProps) => {
    const snakeCaseFormattedStatus = status.toLowerCase().replace(/ /g, '_');
    return (
        <Badge className={cn(styles.badge, styles[snakeCaseFormattedStatus], className)}>{StatusLabels[status]}</Badge>
    );
};

export default BookingStatusBadge;
